import React from "react";
import "./CheckEligibilityBanner.css";
import { Button, useMediaQuery } from "@mui/material";

const CheckEligibilityBanner = () => {
  const isSmallScreen = useMediaQuery(" (max-width:576px) ");
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  return (
    <>
      <div
        className="increase-margines"
        style={{
          backgroundColor: "#E7E4F9",
          borderRadius: 5,
          padding: isSmallScreen ? 30 : 40,
          marginTop: "2%",
          marginBottom: "4%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            backgroundColor: "transparent",
          }}
        >
          <p
            className="minutes"
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isMediumScreen ? 28 : 32,
              fontWeight: 600,
            }}
          >
            Plan Your Dream Wedding Without Financial Worries
          </p>
          <p
            style={{
              color: "#59266D",
              backgroundColor: "transparent",
              fontFamily: "Archivo",
              fontSize: isSmallScreen ? 16 : 18,
              fontWeight: 400,
              lineHeight: 1.2,
            }}
          >
            A wedding is a once-in-a-lifetime event. With a well-chosen wedding
            loan, you can manage your expenses while staying financially secure.
            Minemi helps you compare top lenders, calculate EMIs, and make
            informed decisions. Start your journey towards a stress-free wedding
            today!
          </p>
          <div className=" ">
            <Button
              sx={{
                backgroundColor: "#553285",
                "&:hover": {
                  backgroundColor: "#7a46a3",
                },
                color: "white",
                borderRadius: 3,
                padding: "10px 45px",
                fontFamily: "Archivo",
                fontWeight: 500,
                fontSize: isSmallScreen ? 16 : 18,
                textTransform: "none",
              }}
              onClick={() => {
                window.location.href =
                  "https://minemi.ai/personal-loan/check-eligibility";
              }}
            >
               Check Your Eligibility Now
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckEligibilityBanner;
